"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyHeaderLayoutTranslationKeysWithNamespaces = void 0;
var _languageSwitcher = require("@ori/language-switcher");
var _topArea = require("@ori/top-area");
/**
 * Represents a collection of translation keys used in the DefaultLayout component.
 *
 * This object combines translation keys from various parts of the layout,
 * such as `top area`, `language switcher`, and `footer`.
 *
 * @remarks
 * The translation keys included in this object are essential for providing localized content
 * to users within the DefaultLayout component.
 */
const onlyHeaderLayoutTranslationKeysWithNamespaces = exports.onlyHeaderLayoutTranslationKeysWithNamespaces = {
  ..._topArea.defaultTranslationsWithNamespaces,
  ..._languageSwitcher.defaultTranslationsWithNamespaces
};
